import { cx } from '@emotion/css';
import { RelatedOrderItems } from './RelatedOrderItems';
import { CheckOutlined } from '@ant-design/icons';
import { Status } from './Status';

interface SelectItemProps {
  trade?: Conversation.Trade.Vo;
  active?: boolean;
  isNone?: boolean;
  noneLabel?: string;
  onClick: () => void;
}

const SelectItem = (props: SelectItemProps) => {
  const { trade, active = false, isNone = false, noneLabel, onClick } = props;

  const tradeStatus = trade?.tradeStatus;
  const items = trade?.items ?? [];

  if (isNone) {
    return (
      <div
        role="button"
        tabIndex={0}
        className={cx(
          'pl-1 pt-1 pb-3 pr-3 w-full text-xs border-0 border-b border-solid border-[#E8E8E8] flex items-center justify-between cursor-pointer hover:bg-[#F0F7FF]',
          active && 'bg-[#F0F7FF]',
        )}
        onClick={onClick}
        onKeyDown={(e) => e.key === 'Enter' && onClick()}
      >
        <span className="text-[#84868C]">{noneLabel}</span>
        {active && <CheckOutlined className="!text-[#3370FF] text-[16px]" />}
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className={cx(
        'pl-1 pt-1 pb-3 pr-3 w-full text-xs border-0 border-b border-solid border-[#E8E8E8] flex items-center justify-between cursor-pointer hover:bg-[#F0F7FF]',
        active && 'bg-[#F0F7FF]',
      )}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
    >
      <div>
        <div className="flex items-center gap-1 mb-1">
          {tradeStatus && <Status tradeStatus={tradeStatus} />}
          <span className="font-medium">{trade?.externalTradeId}</span>
        </div>
        {trade && items.length > 0 && (
          <RelatedOrderItems platform={trade.platform} unit={trade.unit} items={items} />
        )}
      </div>
      {active && <CheckOutlined className="!text-[#3370FF] text-[16px]" />}
    </div>
  );
};

interface SelectMenuProps {
  width: number;
  tradeList: Conversation.Trade.Vo[];
  relatedTradeId: string;
  onSelect: (trade: Conversation.Trade.Vo | null) => void;
  onClose: () => void;
}

export const SelectMenu = ({
  width,
  tradeList,
  relatedTradeId,
  onSelect,
  onClose,
}: SelectMenuProps) => {
  return (
    <div className="p-2 flex flex-col gap-2 max-h-[340px] overflow-y-auto" style={{ width }}>
      {tradeList.map((trade) => (
        <SelectItem
          key={trade.externalTradeId}
          trade={trade}
          active={relatedTradeId === trade.externalTradeId}
          onClick={() => {
            onSelect(trade);
            onClose();
          }}
        />
      ))}
    </div>
  );
};
